export default "__VITE_ASSET__BfwaD5Ue__"